import React from 'react';
import { v4 as uuid } from 'uuid';
import cx from 'classnames';
import { PropertyType, toAmountString } from '../../../common';
import styles from './RowProwider.module.scss';
import { find } from 'lodash';
import { allFieldsMap } from './GamesReport.const';

export const getRows = (
	reports: any[],
	columns: string[],
	averageRates?: PropertyType[],
	isTotal = false,
	isGrandTotal = false
): PropertyType[] => {
	const getClass = (amount: number, rate: number) => {
		const amountClass = cx({
			[styles.PositiveAmount]: amount > 0,
			[styles.NegativeAmount]: amount < 0 || rate === 0,
			[styles.Amount]: amount === 0,
		});

		return amountClass;
	};

	const getActiveCells = (r: PropertyType): PropertyType[] => {
		const rows: PropertyType[] = [];

		columns.forEach((column) => {
			const field = find(allFieldsMap, ['label', column])?.key;
			const rate = averageRates && !isTotal ? find(averageRates, ['name', r.currency])?.avg_rate : undefined;
			const currency = rate === 0 ? '' : isGrandTotal ? 'EUR' : r.currency;

			const cellsMap = {
				nrhands: <span key={uuid()}>{r.nrhands}</span>,
				partner: <span key={uuid()}>{r.partner}</span>,
				partner_id: <span key={uuid()}>{r.partner_id}</span>,
				skin: <span key={uuid()}>{r.skin}</span>,
				skin_id: <span key={uuid()}>{r.skin_id}</span>,
				country: (
					<span key={uuid()} className={cx({ [styles.NegativeAmount]: r.country === 'unknown' })}>
						{r.country}
					</span>
				),
				device: <span key={uuid()}>{r.device}</span>,
				provider: <span key={uuid()}>{r.provider}</span>,
				category: <span key={uuid()}>{r.category}</span>,
				game_name: <span key={uuid()}>{r.game_name}</span>,
				game_id: <span key={uuid()}>{r.game_id}</span>,
				bet: (
					<span key={uuid()} className={getClass(+r.bet, rate)}>
						{rate === 0 ? `0 No AVG rate` : toAmountString(r.bet, currency)}
					</span>
				),
				currency: <span key={uuid()}>{isGrandTotal ? 'EUR' : r.currency}</span>,
				win: (
					<span key={uuid()} className={getClass(+r.win, rate)}>
						{rate === 0 ? `0 No AVG rate` : toAmountString(r.win, currency)}
					</span>
				),
				bonus_bet: (
					<span key={uuid()} className={getClass(+r.bonus_bet, rate)}>
						{rate === 0 ? `0 No AVG rate` : toAmountString(r.bonus_bet, currency)}
					</span>
				),
				bonus_win: (
					<span key={uuid()} className={getClass(+r.bonus_win, rate)}>
						{rate === 0 ? `0 No AVG rate` : toAmountString(r.bonus_win, currency)}
					</span>
				),
				ggr: (
					<span key={uuid()} className={getClass(+r.ggr, rate)}>
						{rate === 0 ? `0 No AVG rate` : toAmountString(r.ggr, currency)}
					</span>
				),
				bingo_fee: (
					<span key={uuid()} className={getClass(+r.bingo_fee, rate)}>
						{rate === 0 ? `0 No AVG rate` : toAmountString(r.bingo_fee, currency)}
					</span>
				),
				jp_contribution: (
					<span key={uuid()} className={getClass(+r.jp_contribution, rate)}>
						{rate === 0 ? `0 No AVG rate` : toAmountString(r.jp_contribution / 10000, currency)}
					</span>
				),
				jp_win: (
					<span key={uuid()} className={getClass(+r.jp_win, rate)}>
						{rate === 0 ? `0 No AVG rate` : toAmountString(r.jp_win / 10000, currency)}
					</span>
				),
				sessions: <span key={uuid()}>{r.sessions}</span>,
				uap: <span key={uuid()}>{r.uap}</span>,
				rake: (
					<span key={uuid()} className={getClass(+r.rake, rate)}>
						{rate === 0 ? `0 No AVG rate` : toAmountString(r.rake, currency)}
					</span>
				),
			};
			if (field) {
				rows.push((cellsMap as Record<string, JSX.Element>)[field]);
			}
		});
		return rows;
	};

	const data = reports.map((s) => getActiveCells(s));
	return data;
};
